import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "OpenHAB MQTT Auto-Discovery",
  "path": "/Frequently_Asked_Question/UHD_OpenHAB_MQTT_Discovery/",
  "dateChanged": "2025-11-25",
  "author": "Mike Polinowski",
  "excerpt": "Ihre INSTAR 2K+/WQHD 4K/UHD Kamera unterstützt ab sofort das , das auch von OpenHAB unterstützt wird.",
  "image": "../FAQ_SearchThumb.png",
  "social": "/images/Search/FAQ_SearchThumb.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_FAQs_white.webp",
  "chapter": "FAQs",
  "faq": "WQHD & UHD Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEOHelmet title='Home Assistant MQTT Auto-Discovery' dateChanged='2025-11-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ihre INSTAR 2K+/WQHD 4K/UHD Kamera unterstützt ab sofort das , das auch von OpenHAB unterstützt wird.' image='/images/Search/FAQ_SearchThumb.png' twitter='/images/Search/FAQ_SearchThumb.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Frequently_Asked_Question/UHD_OpenHAB_MQTT_Discovery/' locationFR='/fr/Frequently_Asked_Question/UHD_OpenHAB_MQTT_Discovery/' crumbLabel="FAQs" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "openhab-mqtt-auto-discovery",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#openhab-mqtt-auto-discovery",
        "aria-label": "openhab mqtt auto discovery permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`OpenHAB MQTT Auto-Discovery`}</h1>
    <p>{`Ihre INSTAR 2K+/WQHD 4K/UHD Kamera unterstützt ab sofort das `}<a parentName="p" {...{
        "href": "https://forum.instar.com/t/home-assistant-mqtt-auto-discovery/31314"
      }}>{`Home Assistant MQTT Auto-Discovery`}</a>{`, das auch von `}<a parentName="p" {...{
        "href": "https://www.openhab.org/addons/bindings/mqtt.homeassistant/#homeassistant-mqtt-components-binding"
      }}>{`OpenHAB unterstützt wird`}</a>{`.`}</p>
    <p>{`Im Prinzip könnte man hier einfach der oben verlinkten Home Assistant Anleitung folgen - `}<strong parentName="p">{`jedoch wird zum aktuellen Zeitpunk die „Device“ Klasse noch nicht unterstützt`}</strong>{`:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "615px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/f6b72/OpenHAB_Auto_Discovery_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.21739130434783%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB7ElEQVQoz42Q627TQBCF/TZxfFmvLxsn2V3vxtfYuM2lTZoCJnYapKY0LahCQuqfkFQgniwgJBraPzwOSlMCqlTg6NPsmaMZabQCDxJk26qmabquQijK8hpJLkmSKN2bLZZto2rVsu2yooiSLCB6iujUwCd6faLXjkswF2FeNnLZGslm8QDJyCUjL+tDySjKRiEk2TLJlunw8/B81T/+lr+5efrqOjhcji5ux29vjy5usvPVs+n1hufT1Yuz752jr69nP5Lsi+DtfAh2P0btTzyeVfg7Es1wOK8F7514wZMrnlyxZPEAEs1JOCfhQmjvZSfTy2x42t0fhfEBwZhgy65AVSkBtbSpQBX/RAOiqpQsUxWY28vHl/uDs929Sas74Y0mZwxjomkQQv0xNA0iVBFw3W630jSNGKtzVqeUNOM4CHz4V2mahhASOHfH45f9/kEUNTeKoogx9s9ly7IE6jhFUXS7Hc91G7yRpjsNzgEA/7WMMWm3WsmTxPc9x3E81/M8V39EEG4NXJ+NMRmNisHhIAxD0zTu/gkCANRf2vrfkQoURTFNUwAAdDqdfq+HEGKMEUIYZ4QSQgmlhHNOCKGOQyldZ5RuZu46IjDGkjgJo2h9ruv6vh+GYa1Ws227Wq1uzUYY4/VzH9k/Afv7yI7e3eA5AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/e4706/OpenHAB_Auto_Discovery_01.avif 230w", "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/d1af7/OpenHAB_Auto_Discovery_01.avif 460w", "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/3b39a/OpenHAB_Auto_Discovery_01.avif 615w"],
              "sizes": "(max-width: 615px) 100vw, 615px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/a0b58/OpenHAB_Auto_Discovery_01.webp 230w", "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/bc10c/OpenHAB_Auto_Discovery_01.webp 460w", "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/26ec8/OpenHAB_Auto_Discovery_01.webp 615w"],
              "sizes": "(max-width: 615px) 100vw, 615px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/81c8e/OpenHAB_Auto_Discovery_01.png 230w", "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/08a84/OpenHAB_Auto_Discovery_01.png 460w", "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/f6b72/OpenHAB_Auto_Discovery_01.png 615w"],
              "sizes": "(max-width: 615px) 100vw, 615px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/b1a20d72d6b2edf022d9f49b4c2f3623/f6b72/OpenHAB_Auto_Discovery_01.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Wie Sie in dem Screenshot sehen, wird im Falle von Home Assistant ein „Gerät“ (device) registriert und dieses bringt dann eine Konfiguration für alle untergeordneten Funktionen des Gerätes mit sich.`}</p>
    <p>{`Sobald dies von OpenHAB unterstützt wird, müssen Sie nur noch das „Discovery Präfix“ (s. `}<a parentName="p" {...{
        "href": "https://forum.instar.com/t/home-assistant-mqtt-auto-discovery/31314"
      }}>{`Home Assistant MQTT Auto-Discovery`}</a>{`) mit dem abgleichen, was Sie in OpenHAB verwenden.`}</p>
    <p>{`Bis dahin stellen wir die einzelnen Funktionen der Kamera über das „Discovery Präfix“ `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`openhab_discovery`}</code>{` bereit. Sie können also einfach eine neue Entität, z.B. einen Button, über MQTT mit dem entsprechenden Topic hinzufügen.`}</p>
    <h2 {...{
      "id": "mqtt-broker",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#mqtt-broker",
        "aria-label": "mqtt broker permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MQTT Broker`}</h2>
    <p>{`Wenn man bereits einen MQTT Broker in OpenHAB konfiguriert hat, kann man die Kamera einfach mit diesem verbinden und zum nächsten Schritt springen.`}</p>
    <p>{`Sollte noch kein Broker vorhanden sein, kann die Kamera selbst als Broker verwendet werden. In OpenHAB braucht man dafür zuerst das MQTT Binding:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/b960dd6e47c7f95c81840d04803ca4fa/7a1fb/OpenHAB_Auto_Discovery_02.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "86.5217391304348%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAACcElEQVQ4y32STWvUQBjH0/biatvNZJImmclMMi95fzO73ZaCiItWWAulKHrRgiB+ACsKfo3aqxSW4qFfwIPgxY/Qa714KupNrD1KEqpbtf1d5mFm/vyfN4VzXlVVlmWDwYBzDuZnyzwf3RmN1kbD4ZAxRil1XdfzPF3XtbMohJA4ioMgSJKEUqooynhvfPLl5ODdwc8fxxv37uZVtbS0vLi4aFmWqqoTWqBEUex63LKxhTB1vampqb23e4cfDvdf7n/9/G1t9WagQ2yac3Nzf9lqECrXVpaHK/3Md0NqRcyZmZkevxkffTz69P7w+9Hx1sb6izIrMZqvP7eS5gAAmki5OlzvP3gubj+xh4/pjYedK7Obm492d3d3Xu9sb297XExf6syrNd1TVFUFANQ1e4PV4P4rubGF7jxDt57qhnm50+l2u0Ctnz3XjQJfCsEaeAPGWNd1ADQlEKyMRJX4oYe5YwIAKKVlWfaqXr/Xy/PcDwIhRCuTUgohEEKmaUIIFd8P4iRN0iyMIsYFAIBzHsdRGCVExtghGCOEEMbYtm3LstqYEGIYRt3tqiHLMsYYAEBKWRRFluVxmsdJjd8QnBKGYRSFCNlKUZT9fr8oijY3TdMIIW3sS+n7PmPMPgUh9DswLVtJ0yzLsjAM26pgg67rEMLJ3k6iNleaYSmc87aLUsp6PQEQQhRFIaVsp/ovZoOh64qYoE0bY+w4DjwfhJDv+2manhEzxjRNs217YWHhPFsIIQAAQkgI+b9zO4mLzYWUf8RtzbWzZVFK6zU43xwhRBysVL1+VfW4EJ7nEUI1DRi2Y7m+YaELxBBCu7j+CxnJlFS9WUWEAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b960dd6e47c7f95c81840d04803ca4fa/e4706/OpenHAB_Auto_Discovery_02.avif 230w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/d1af7/OpenHAB_Auto_Discovery_02.avif 460w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/7f308/OpenHAB_Auto_Discovery_02.avif 920w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/db5a9/OpenHAB_Auto_Discovery_02.avif 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/b960dd6e47c7f95c81840d04803ca4fa/a0b58/OpenHAB_Auto_Discovery_02.webp 230w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/bc10c/OpenHAB_Auto_Discovery_02.webp 460w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/966d8/OpenHAB_Auto_Discovery_02.webp 920w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/a820a/OpenHAB_Auto_Discovery_02.webp 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b960dd6e47c7f95c81840d04803ca4fa/81c8e/OpenHAB_Auto_Discovery_02.png 230w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/08a84/OpenHAB_Auto_Discovery_02.png 460w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/c0255/OpenHAB_Auto_Discovery_02.png 920w", "/de/static/b960dd6e47c7f95c81840d04803ca4fa/7a1fb/OpenHAB_Auto_Discovery_02.png 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/b960dd6e47c7f95c81840d04803ca4fa/c0255/OpenHAB_Auto_Discovery_02.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Nach der Installation geht man auf die Konfigurationsseite des Bindings:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/a36c911a33d50c3d747e981396f0334d/7a1fb/OpenHAB_Auto_Discovery_03.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "46.52173913043478%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAABNUlEQVQoz3WPS07DQAxA5wSF5tMk88mM50/SyaRBXdBWaiVuwArECTgFexbcgLuiJAqLAk9PtmzLsoyEECEE732MEQAao721Uiq74JzbDcN+v/feG2PmprFWW4M45zHGEMIwDIwxjMld04TtVkoJC3VdM8Z+SgGgJHglkdYGE5rleb4pyrK6Wa26Ll7OF2Ms5wJAznIBhNBZTKigrOUcHQ8P59Ox9c5qqaVIkiSE7nA8WeuEENOhkTHyOQNjNcYEE4rM46t/+6IvH/nzZ/n0nm7KsijGGcZVNUkoruUorasRXC0g5Vq/O6hwD+0gfEzTLMvGJ7JsMS/yko5uymwa/ois0X23tVoqECB4mqZJsr5yvb6dveojY23TttoYpTSAnJZ/k05eg6xzfd9775VSAPDP8t98Awk7QSXxBHaSAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a36c911a33d50c3d747e981396f0334d/e4706/OpenHAB_Auto_Discovery_03.avif 230w", "/de/static/a36c911a33d50c3d747e981396f0334d/d1af7/OpenHAB_Auto_Discovery_03.avif 460w", "/de/static/a36c911a33d50c3d747e981396f0334d/7f308/OpenHAB_Auto_Discovery_03.avif 920w", "/de/static/a36c911a33d50c3d747e981396f0334d/db5a9/OpenHAB_Auto_Discovery_03.avif 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/a36c911a33d50c3d747e981396f0334d/a0b58/OpenHAB_Auto_Discovery_03.webp 230w", "/de/static/a36c911a33d50c3d747e981396f0334d/bc10c/OpenHAB_Auto_Discovery_03.webp 460w", "/de/static/a36c911a33d50c3d747e981396f0334d/966d8/OpenHAB_Auto_Discovery_03.webp 920w", "/de/static/a36c911a33d50c3d747e981396f0334d/a820a/OpenHAB_Auto_Discovery_03.webp 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/a36c911a33d50c3d747e981396f0334d/81c8e/OpenHAB_Auto_Discovery_03.png 230w", "/de/static/a36c911a33d50c3d747e981396f0334d/08a84/OpenHAB_Auto_Discovery_03.png 460w", "/de/static/a36c911a33d50c3d747e981396f0334d/c0255/OpenHAB_Auto_Discovery_03.png 920w", "/de/static/a36c911a33d50c3d747e981396f0334d/7a1fb/OpenHAB_Auto_Discovery_03.png 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/a36c911a33d50c3d747e981396f0334d/c0255/OpenHAB_Auto_Discovery_03.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Und wählt dort zuerst MQTT Broker, um die Kamera als Broker hinzuzufügen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/de8711df4bbbeba24a28e7911ba46784/7a1fb/OpenHAB_Auto_Discovery_04.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.391304347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAABNklEQVQY022Nu07DMBiFs3SAqqrtNmkudhIn/t06aRw3qAilJEDLygYsZYSJZ+jGzMAb8KYovTAgPn3LOdLRseI4LooiyzJjDOc8A5HNZiCPgJSFmi5UsshEmcnf/oAVRZHWOs9zYwxjzA8CFob0AGPUc1jZpk878bxjVw/UdbryhAUgA8ps27Gdiet5GKHhCYQxGpxjXnib1+D+jagVGpwhjBAaHrTqum6aa6UUAIg0JYSkaaq19n1/RMjYtsd4SPo90u+N0aCLe7oz27HEZjt9/6Yvn/b2y338wCOn1Prm9q6qLjhPKGWURTTknSzax9B3J7Bcy+XaSqWalpciN4nSfDrHGBuzqOsVgDyO/8jCwJ2IqoGqsSQIo+dSJCmPkzjCGJeladsWAOKY/zOmjAY05BAl8gf7ODpFoM+NoQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/de8711df4bbbeba24a28e7911ba46784/e4706/OpenHAB_Auto_Discovery_04.avif 230w", "/de/static/de8711df4bbbeba24a28e7911ba46784/d1af7/OpenHAB_Auto_Discovery_04.avif 460w", "/de/static/de8711df4bbbeba24a28e7911ba46784/7f308/OpenHAB_Auto_Discovery_04.avif 920w", "/de/static/de8711df4bbbeba24a28e7911ba46784/db5a9/OpenHAB_Auto_Discovery_04.avif 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/de8711df4bbbeba24a28e7911ba46784/a0b58/OpenHAB_Auto_Discovery_04.webp 230w", "/de/static/de8711df4bbbeba24a28e7911ba46784/bc10c/OpenHAB_Auto_Discovery_04.webp 460w", "/de/static/de8711df4bbbeba24a28e7911ba46784/966d8/OpenHAB_Auto_Discovery_04.webp 920w", "/de/static/de8711df4bbbeba24a28e7911ba46784/a820a/OpenHAB_Auto_Discovery_04.webp 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/de8711df4bbbeba24a28e7911ba46784/81c8e/OpenHAB_Auto_Discovery_04.png 230w", "/de/static/de8711df4bbbeba24a28e7911ba46784/08a84/OpenHAB_Auto_Discovery_04.png 460w", "/de/static/de8711df4bbbeba24a28e7911ba46784/c0255/OpenHAB_Auto_Discovery_04.png 920w", "/de/static/de8711df4bbbeba24a28e7911ba46784/7a1fb/OpenHAB_Auto_Discovery_04.png 1030w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/de8711df4bbbeba24a28e7911ba46784/c0255/OpenHAB_Auto_Discovery_04.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`An dieser Stelle sollte man sicherstellen, dass der MQTT Dienst in der Kamera aktiv ist und die Kamera als MQTT Broker konfiguriert ist:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "851px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/73e409d16c47a7962d827fa4976b1127/0fcea/OpenHAB_Auto_Discovery_05.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "96.08695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAACuklEQVQ4y22Ty4scVRTGa2nATN/369zHuY+q6mZS3T1klCCCiItkZ4gOTKIJ6saQpX+Fg1s3+W9DVfW0CRG+VRU/vu8759xOKsWEoJwzISklCi/D9Y/m8Eztn6rp/+WOz9LXz2W96riQjAvKOBdyc/FluHq6f/PvcHOXX/xdfrr7XPnF3eXLf7758/34wx8d5ZIyQYUklBNCuVQ+IdYKMWnnDQT7mQxEXSYXS8eUoUIxoRaecSFLbbvdrh/HiJhyBg/aWmOdtnaVBR/qyDTMMOOSSU0Y3xAqpLLgtXUWQsolYgkJjQML3ofoYwIfjANjHYTYMWlmWy4IZWSB9fzPVoRtj7sety1hmN18jDElH6JxoKwvwXRMaiokZXyGKeNSYqm1bxCCnqM6bawByLWV1vuELsQQ0cU0VuwW23lm97BKOWMpWGpMCIuPAV/7PpcWMS8qFvy0P3R0hfkZliFhwuxj1M7N5FK4tD5iDmmGUy7Oh+lw7Li2CywJO60qYcZ5VPlku8C5tlyqj8nHFBJa8I+mfTcXForKdVV0jZ1ywVJCSmd42O7aMGKpWGquzUe8nA7dhtJl1Ysz/c855exC+Dh2yjXN3+dx+BjbMHaEsfuBC8LmzrnW2vdtGCKitufan8jXrdC2I5SxNTkXm8UZQlzl/MnZOJDaSx1OUl6FUSjTEUqZNOttLrEl5lpaAx/Otg5cP9hh1Ge1Xgsl587rtghja2zMpZQC3q+kMoDZvnmlf3998evtg9cvH/z2yxc/P7/QRp7Pc3beECakFC4ym5gJyoJ1oOeK7jDx435zmDa7o9ge+TApoVRHl8e8XgihdMP1zWPy1/cP3377cECrXHAANqD96jZ899Y9vrkN23d4+SqORunuHjvBVMgpyyeDuG7cWS20kdpI42w7+N21rdMR/JMQr8ALLj4AlAiHyEwnFVIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/73e409d16c47a7962d827fa4976b1127/e4706/OpenHAB_Auto_Discovery_05.avif 230w", "/de/static/73e409d16c47a7962d827fa4976b1127/d1af7/OpenHAB_Auto_Discovery_05.avif 460w", "/de/static/73e409d16c47a7962d827fa4976b1127/7aa96/OpenHAB_Auto_Discovery_05.avif 851w"],
              "sizes": "(max-width: 851px) 100vw, 851px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/73e409d16c47a7962d827fa4976b1127/a0b58/OpenHAB_Auto_Discovery_05.webp 230w", "/de/static/73e409d16c47a7962d827fa4976b1127/bc10c/OpenHAB_Auto_Discovery_05.webp 460w", "/de/static/73e409d16c47a7962d827fa4976b1127/155dd/OpenHAB_Auto_Discovery_05.webp 851w"],
              "sizes": "(max-width: 851px) 100vw, 851px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/73e409d16c47a7962d827fa4976b1127/81c8e/OpenHAB_Auto_Discovery_05.png 230w", "/de/static/73e409d16c47a7962d827fa4976b1127/08a84/OpenHAB_Auto_Discovery_05.png 460w", "/de/static/73e409d16c47a7962d827fa4976b1127/0fcea/OpenHAB_Auto_Discovery_05.png 851w"],
              "sizes": "(max-width: 851px) 100vw, 851px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/73e409d16c47a7962d827fa4976b1127/0fcea/OpenHAB_Auto_Discovery_05.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "851px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/c71f20aa0a94a146393681fab8021d1c/0fcea/OpenHAB_Auto_Discovery_06.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "96.08695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVQ4y5WTTY8cNRCGGwgim+3ucZU/2nbZ5Y+e7EA2M7uBEAUukSBiIxQg2ihIKFIOufBXWOWaC/828vQyBFAOSO/Fkp96q+q1O20MKgVSotIAwuTTeP8Xe/bEbC8+JH/+JD14pud7nVQapQKUUunV2Md7F7tXb09eXNXLP+rzq/+qXF6d/vbm29//3Hz/ugOpARUoLUAKAVKbkEqqs49sKVgKjuK/ZImnuvVcOzQWlEFl9jxKpeb1erPZ1HlOJedSKITJOeu8sXaRoxDnDU7UYJQa9SRQrgQobSyR9eQoBE6BE0VejjEXziVwsp6s8xS5Q22brVQCUAhssKfJeecpcIqcQmTv/TrTF7fznU35fM0pOuNCjbZDPYHSgLLBgFIbziXXyikvVVohCpwLhbi0QCFOPmzm3O1t284OcMql1Dnl4tu0vjXpKZWaSqXIPkSKbKy7uzvrYIHlAdac254i58DtaoMppFI5Z4pMkQOnyfnt2XknJ7eHtcDrqFKupc651MDpGm7OhVP2If7tvN11bWBlQC9RwfXMrckyOVrIBtd56fkAn2533QpgH/Xeed92LmWea875QFrnwvo0ru9SjDEyc/IU1iebTiAuCxeoBKLSWlMGXySVyYcDH4ONNHlnhKfRexmjMqYT0Ai4jhpAmUd31OVX8uk55n2e1ntLTLvv0tdPw/bRY67P6u3HqRrdYEBtl7cpAIQyFzv56qH49b6o/BccOH75Y/7mRTz/4ac0vywnP+d50qbNvKQlEAUiIB6N8qMj8cktcTyshnFc1B9/dnz0aX9888YwfDz0N4ahH8fD81ycmwDEOPbj0PfD8J7Gfhz7VmlY1A9DB/vPfCAF4ErAP7EPqnsf+7/wO+9FeSWYTn2GAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c71f20aa0a94a146393681fab8021d1c/e4706/OpenHAB_Auto_Discovery_06.avif 230w", "/de/static/c71f20aa0a94a146393681fab8021d1c/d1af7/OpenHAB_Auto_Discovery_06.avif 460w", "/de/static/c71f20aa0a94a146393681fab8021d1c/7aa96/OpenHAB_Auto_Discovery_06.avif 851w"],
              "sizes": "(max-width: 851px) 100vw, 851px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/c71f20aa0a94a146393681fab8021d1c/a0b58/OpenHAB_Auto_Discovery_06.webp 230w", "/de/static/c71f20aa0a94a146393681fab8021d1c/bc10c/OpenHAB_Auto_Discovery_06.webp 460w", "/de/static/c71f20aa0a94a146393681fab8021d1c/155dd/OpenHAB_Auto_Discovery_06.webp 851w"],
              "sizes": "(max-width: 851px) 100vw, 851px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/c71f20aa0a94a146393681fab8021d1c/81c8e/OpenHAB_Auto_Discovery_06.png 230w", "/de/static/c71f20aa0a94a146393681fab8021d1c/08a84/OpenHAB_Auto_Discovery_06.png 460w", "/de/static/c71f20aa0a94a146393681fab8021d1c/0fcea/OpenHAB_Auto_Discovery_06.png 851w"],
              "sizes": "(max-width: 851px) 100vw, 851px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/c71f20aa0a94a146393681fab8021d1c/0fcea/OpenHAB_Auto_Discovery_06.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Zurück in OpenHAB kann man jetzt die ensprechenden Daten hinterlegen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/3f97db8c9167802f5afeda19f96a75c2/2e694/OpenHAB_Auto_Discovery_07.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "84.78260869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAACL0lEQVQ4y22TS3LcIBCGOUFsgx4goHmDBpWsGdWUZ2xvUlln7VwgV8gNsskBct9EwlLsJF/1QiB+upvuRkKIEILWOoSwfEtulJIAckUIEWOc53maJqWUEEJuAADSWp/P59PpdL1eAeDDzY33wVrLOS9HD/1BayOl1NoALHrOOQAopZAPQUiom6aum7alhBDvgzFWinK7ynm4v59yHoyxAEpKKNZ1HD0/PT0/PfYxBues1hjjlHrnPOei+PY+OOelhLLcjXOO/MeX8PUnf/nefvlBP3+7I3Xfp3me+76v67qqKkIIXiEbeFsjfxjHx0/heDXjAxyOGBNGqZRSKSWlrKrq9vb27j1VVTV1XROMgne5j8Fqb5QGSTCmlHZdt/wlZDn3D6BUdM5ximKM0zSFEJxz+jXndDweywsDKM55t8HYYnSlaVsUQhzHMaW0i621UkrGGF8QlDL6B0YpK1BK0TRN8zwPw+CcM8YQQqy1S6kkrGWG3QCW8lDK2paury3Q8Xg6n8/jOO5ipXSMUWvDi+uVrluibVvatm1d1957bQzKOQ/DEGMsYoyx9yHnIca0OS9VFYyxVUyrqk6p994ju7FctuYMAFprANj6Qez+i7hp2rKP3EYRV4Sc+uh9KB32V1e9yV8ppZFf2cUYY6N1znkr1TJe9H80TbNMldZqDfu1VM75lFLXdbvz7j2MMSEEgEIPD5fL5ZJSstYKIStC7r3NeRDLJMhibyPf7fdU/QI503r6wbCmvgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/3f97db8c9167802f5afeda19f96a75c2/e4706/OpenHAB_Auto_Discovery_07.avif 230w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/d1af7/OpenHAB_Auto_Discovery_07.avif 460w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/7f308/OpenHAB_Auto_Discovery_07.avif 920w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/7118b/OpenHAB_Auto_Discovery_07.avif 1048w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/3f97db8c9167802f5afeda19f96a75c2/a0b58/OpenHAB_Auto_Discovery_07.webp 230w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/bc10c/OpenHAB_Auto_Discovery_07.webp 460w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/966d8/OpenHAB_Auto_Discovery_07.webp 920w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/85e27/OpenHAB_Auto_Discovery_07.webp 1048w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/3f97db8c9167802f5afeda19f96a75c2/81c8e/OpenHAB_Auto_Discovery_07.png 230w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/08a84/OpenHAB_Auto_Discovery_07.png 460w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/c0255/OpenHAB_Auto_Discovery_07.png 920w", "/de/static/3f97db8c9167802f5afeda19f96a75c2/2e694/OpenHAB_Auto_Discovery_07.png 1048w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/3f97db8c9167802f5afeda19f96a75c2/c0255/OpenHAB_Auto_Discovery_07.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Die Broker IP ist die IP Adresse der Kamera und der Port - wenn nicht in der Kamera angepasst - ist 1883.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/f12eaca637ccae8c42cf7f84f60699cc/2e694/OpenHAB_Auto_Discovery_08.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "84.78260869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAACfUlEQVQ4y21Ry47bRhDkzQgCS+SQQzY53T1vkpKWkLTWipJs+JFcc3ZuOeWei/MHueQD8gk++h8DktFmgaRQKBYB1vRUM0HEGKMxJsY4eVLRh7btu24TQkuku25zOp2PxzfGOEQm0gp5Y+0QQ2KMOZ1Ox+Pxcrkw82qdOqfbaIJnH9g5NKZhhqYplJKoSlSlakpLoLFOQoxILMtSyrKqQIj8OupPH4rLeXV5en09ryaOq9u4vo3r6zj5y3n1/t267yF5e7u9vV37to3eO2uEEJuehgfVd2XXyv9nlER13TRJ+Pg5/vqX+vxH9fOf8NPvWS6fHtXH9/V1XE/D/8PrdKOVNVDXKgmbYbj+EA8XO4y8OYg8J7bebxB9IRtZopTqJUup0rw5Or5sQhKD3/ZtdCZYbZiEEMwUY7DOMuFEJuZFieZXIrSaNWHStu1+v48xeu+NMXmeM7MxFqCuKqj+BdwVoIIKoKyqJMZ2GIau65awEIKIF2+tsxMWnYwxVmujtWmQ8kIm+/3+8fFxt9t57621QghEdM4ZY/QdzBO11kRUQ10B6Aa4huRwOJ5Op2EYnsPOub7vnfNKISISzUJT1+nBDArPnb9sY7Ldbne7Xdu2z2Gl1DKE5+XAjKZpAKBeACArSEWeuDtCCHPn3DkfYzvtFCcqhS+JOCkhqkYl/o57WADAMtPcobV+NksBWcEqTZMw42XY+/Dw8OC9n5dlNBNjQ6qZy2MNUJTVwdJT55PlROfc86+q62a+m/qnIXJRk6hUIcuiKKSURSERSq6r5Hwex3Hsus45h0hC5FmWpmmaZVkm8vT7V9WHX4Yv33a/fZX7H7PX32XTB9l65t+LpoKzno2apAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f12eaca637ccae8c42cf7f84f60699cc/e4706/OpenHAB_Auto_Discovery_08.avif 230w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/d1af7/OpenHAB_Auto_Discovery_08.avif 460w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/7f308/OpenHAB_Auto_Discovery_08.avif 920w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/7118b/OpenHAB_Auto_Discovery_08.avif 1048w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/f12eaca637ccae8c42cf7f84f60699cc/a0b58/OpenHAB_Auto_Discovery_08.webp 230w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/bc10c/OpenHAB_Auto_Discovery_08.webp 460w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/966d8/OpenHAB_Auto_Discovery_08.webp 920w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/85e27/OpenHAB_Auto_Discovery_08.webp 1048w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/f12eaca637ccae8c42cf7f84f60699cc/81c8e/OpenHAB_Auto_Discovery_08.png 230w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/08a84/OpenHAB_Auto_Discovery_08.png 460w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/c0255/OpenHAB_Auto_Discovery_08.png 920w", "/de/static/f12eaca637ccae8c42cf7f84f60699cc/2e694/OpenHAB_Auto_Discovery_08.png 1048w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/f12eaca637ccae8c42cf7f84f60699cc/c0255/OpenHAB_Auto_Discovery_08.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Das Login hier ist das Login, das man bei der MQTT Broker Konfiguration in der Kamera hinterlegt hat (nicht das Kamera Login!).`}</p>
    <p>{`Nach dem Speichern der Einstellungen ist der Broker verbunden:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/cc45bd791dc8858fce5f4cfe5810b636/71ee9/OpenHAB_Auto_Discovery_09.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "74.34782608695652%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8klEQVQoz2WSuXLWMBRG/QpetC9Xslb795I4yTADMwz00FBQUdLzGvQUvC4jK/mzcOYrVOhIule38d6nlEIIKSWQMo/GAFihrbWmLOE4jvu7u3melVL6BIwJRiWjmxDCum/bvm/7DWVMKuWCne6j1EoIwRijlEopKaXsCSklF5Iy3uScATQ54VyAgvESLl8OoRVnQgjJueC8LK7hXIzWaQ3N+4+f7z988tMWLrsEizGxMIqB100AJoTofTDGvvY5QqixX3/5n3/J99/0x5/h3TeG2mledCkWlNLeh2VZU8oARmu4Rind932T8rTuu/PRh8SFIISs6xJjoJQOw4BPhmFA/9F1XRNjmHIerfVu5JwhhLZtW9eNc05PCKEvwZjUlxd5muZ9v3HOee+FEMMwzPO8LAuAaduu74c3IaQ0nxBS5JTysiz+pLZhHEcAQx6hb5BSAhjOeZFvb4+Hh4ecc70ZY3y5LDFGKaVSWpQu1Jezmnrco7zv+3EcKaWrnHOOMQIYpbRSqlZYjyCEYowBYJqmtm2beFJrrs8OJ+fHltmoMMavN2sNKaUijycv5ZiSc15rLeXzVJwTyjAmCGHOhbVj17WNe6LKDON9WZzzjPEXpiodKFWUSKkATBmStzIasndg7NmwQv0YQgjGz0EI9333D8HTbBoXFPoeAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/cc45bd791dc8858fce5f4cfe5810b636/e4706/OpenHAB_Auto_Discovery_09.avif 230w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/d1af7/OpenHAB_Auto_Discovery_09.avif 460w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/7f308/OpenHAB_Auto_Discovery_09.avif 920w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/48bb5/OpenHAB_Auto_Discovery_09.avif 1081w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/cc45bd791dc8858fce5f4cfe5810b636/a0b58/OpenHAB_Auto_Discovery_09.webp 230w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/bc10c/OpenHAB_Auto_Discovery_09.webp 460w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/966d8/OpenHAB_Auto_Discovery_09.webp 920w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/c5fc0/OpenHAB_Auto_Discovery_09.webp 1081w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/cc45bd791dc8858fce5f4cfe5810b636/81c8e/OpenHAB_Auto_Discovery_09.png 230w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/08a84/OpenHAB_Auto_Discovery_09.png 460w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/c0255/OpenHAB_Auto_Discovery_09.png 920w", "/de/static/cc45bd791dc8858fce5f4cfe5810b636/71ee9/OpenHAB_Auto_Discovery_09.png 1081w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/cc45bd791dc8858fce5f4cfe5810b636/c0255/OpenHAB_Auto_Discovery_09.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "hinzufügen-der-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#hinzuf%C3%BCgen-der-kamera",
        "aria-label": "hinzufügen der kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hinzufügen der Kamera`}</h2>
    <p>{`Zurück in der Konfiguration des MQTT Bindings müssen wir jetzt eine „Home Assistant MQTT Komponente“ hinzufügen. Diese setzt den bereits vorhandenen MQTT Broker vorraus:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/71ee9/OpenHAB_Auto_Discovery_10.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "61.73913043478261%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVQoz2WPy47TMBSG8wCoSZo4Vx/bie04SeO0caaZJm1Aw44RIGDBLOcJ2LJBQuIBeGfUdjrA9NO/OPJF33+soij6vt9sNn3fU0qbUimligtKqbaSupK6/nv4jJViyIXkUuZchFH8L1EYRimQLz/k42+4/xZdeLqNImvT6lpkECGI/CREjuMsTtiO4zi24y79aozWd77snQu2vbAXC9d1re3d/fDhMd+9y8b3eHXre94wDDc3N0mSIBQEQRi4C+S8Cpb2cQ5ChFAMWUL40nUtOn3KHn4lH79Hn38G09fA9+b5zTTt63pFKQMgQNgp9DRTHMeim+X27dJZWErwdV1IhiVLIQlREIzj1HWGsYwQijH8H5LGMW+2Yj0tHdsqVNmuN0IWQhYYCEJonl8b02dZzlh2tF0HA2Dwfd+SUtZ1LU5gjBEKDodZqTJNMQC5Mj/5MSae51lN0xjTlWXJOQcAhNA4jsb0VVUDEEIopexFzhsdPxtjhmFomkYIQcix9jDc7nZj2661bpUq85znOedcPA+cC0rZ2ay11kopIcTZvN8fxnHSWlfV6vzu2gxwqs0vXHZGxvRdZ5QqCaGMZXnOsyx/kXPtP351YeWZ6yTDAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/fccb0de22b46d131ccdffb29d7b71f6c/e4706/OpenHAB_Auto_Discovery_10.avif 230w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/d1af7/OpenHAB_Auto_Discovery_10.avif 460w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/7f308/OpenHAB_Auto_Discovery_10.avif 920w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/48bb5/OpenHAB_Auto_Discovery_10.avif 1081w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/fccb0de22b46d131ccdffb29d7b71f6c/a0b58/OpenHAB_Auto_Discovery_10.webp 230w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/bc10c/OpenHAB_Auto_Discovery_10.webp 460w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/966d8/OpenHAB_Auto_Discovery_10.webp 920w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/c5fc0/OpenHAB_Auto_Discovery_10.webp 1081w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/fccb0de22b46d131ccdffb29d7b71f6c/81c8e/OpenHAB_Auto_Discovery_10.png 230w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/08a84/OpenHAB_Auto_Discovery_10.png 460w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/c0255/OpenHAB_Auto_Discovery_10.png 920w", "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/71ee9/OpenHAB_Auto_Discovery_10.png 1081w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/fccb0de22b46d131ccdffb29d7b71f6c/c0255/OpenHAB_Auto_Discovery_10.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Wie oben beschrieben kann man (zur Zeit) leider nicht die `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`device`}</code>{` Klassen verwenden, die unter dem Home Assistant Discovery Topic `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`homeassistant`}</code>{` bereitgestellt wird. Daher verwenden wir hier das `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`openhab_discovery`}</code>{` Präfix und eine Reihe von Kamera Funktionen, die darüber zugänglich sind:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/e3829/OpenHAB_Auto_Discovery_11.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.6086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAACNUlEQVQ4y4WTza7TMBCF/Qbo1nb+7Bn/xnacJk2aFhWQuHfPng071rwHWxY8MEpKq4p7JT4dRVaSI5/RzBDvfQihbducM4LMzmilrF5RSnnvT6fluNH3vRACAVApozBrJCGEeZ4Ph8M8z1VVlXUTQ4jGACoEJaVUSrVta4xVSlnrEBUAAGJR1cQ7J4QoeHEV5zzGTsj1OwAaY4dhzLnPubfWaW20NqsVdV3V5PPz8+XjJx9iGxMqRSmbpqnP/ZqirKqqquu6LKuiKB9Y33POif7yw33/XX79WX77Vbx8Z0/vrPNCyO3v6i6xhkH4CyJiURQkTefx8mKHkx3eS5co3aWUcs5CiKenHaV0t0HfgsTQ5hSd0d4akIJSmnM/jgdEJYSUt+IBUEowxlrrrHXG2KqqSEppv98757z3AMA53++Hw2GapnlZTil1V8WYYkxdl2NMOffet2VZka7rpmkKITjnAIAxNo6H4/EYYyqKkvOCMX4XpezGeibXDscYrzczxuZ5XpYlxiiEbJpGvKJphFK6aRoyz/P5fM45e+8RkbG1z12Xuy73/V4p/Vj2vXjvWwBcY3dd5zeuNW9RjtM0hxBfOwFQCBlCVEoRe+MWm/f9fhhGa92tt/jmzYhI3I17zSmtsY2x2zCodSDWp7rapAQhpDFGCEGutruZUqq1BgBx67JcgU3ycUQZY2RbPn2PzTkfhnEcR0RV180/ekAURUkulw/LcvJ+Xbq6bna73bYSK7v/8QcH93/ybfELhQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/d46d706dd20379f28e9cc2bfd122cd0e/e4706/OpenHAB_Auto_Discovery_11.avif 230w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/d1af7/OpenHAB_Auto_Discovery_11.avif 460w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/7f308/OpenHAB_Auto_Discovery_11.avif 920w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/969b5/OpenHAB_Auto_Discovery_11.avif 1077w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/d46d706dd20379f28e9cc2bfd122cd0e/a0b58/OpenHAB_Auto_Discovery_11.webp 230w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/bc10c/OpenHAB_Auto_Discovery_11.webp 460w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/966d8/OpenHAB_Auto_Discovery_11.webp 920w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/f0bfb/OpenHAB_Auto_Discovery_11.webp 1077w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/d46d706dd20379f28e9cc2bfd122cd0e/81c8e/OpenHAB_Auto_Discovery_11.png 230w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/08a84/OpenHAB_Auto_Discovery_11.png 460w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/c0255/OpenHAB_Auto_Discovery_11.png 920w", "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/e3829/OpenHAB_Auto_Discovery_11.png 1077w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/d46d706dd20379f28e9cc2bfd122cd0e/c0255/OpenHAB_Auto_Discovery_11.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Achten Sie hier darauf, dass Sie als „Parent Bridge“ den MQTT Broker auswählen, mit dem die Kamera verbunden ist (bzw. den sie selbst bereitstellt). Das „MQTT Basis-Präfix“ ist `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`openhab_discovery`}</code>{` und die Konfiguration-Topics müssen `}<strong parentName="p">{`OHNE`}</strong>{` die `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/config`}</code>{` Endung eingetragen werden!`}</p>
    <h3 {...{
      "id": "beispiel",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#beispiel",
        "aria-label": "beispiel permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Beispiel`}</h3>
    <p>{`Man möchte einen Button einfügen, der die Kamera auf die gespeicherte Position 1 fahren lässt.`}</p>
    <p>{`Um das entsprechende Topic zu finden kann man z.B. den `}<a parentName="p" {...{
        "href": "/de/Erweitert/INSTAR_MQTT_Broker/Windows_macOS_und_LINUX_Apps/#mqtt-explorer"
      }}>{`MQTT Explorer`}</a>{` verwenden:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/9e0b777024a44170612a3f920362d98a/3dde1/OpenHAB_Auto_Discovery_12.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.17391304347827%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAACZUlEQVQoz12O6W7TQBSF/SgVpU6cOOOsnsWJPTO2x87MeInd7K3oIhZRxA+eg1cpgioFHg8lpQH10/fr6B7dY0C/BIMY9KOG7Tc7f7U6QQvQ7kiAwVMeHPKg2Qkatt+w9wdthxms/j5d7fR2Jze7eP5Q3/4ur37ml4/55aPa7rLLR7nZYXnv6Xui773sW7J84NWP89vd7Zdfxmx+Vy0+cbH12ZL4tYtzlxRHhyibsGVefRDyKlHXqb5J9XWi3sj8TaIujSjy8zwleDgcgH7P7nbbDrCOduwGRoO60kWeloUsC3leZzrLdFZHYWS4EC0Wi/O6ShLBGA2jEHRsx+k8adtthJCUWggRRlPG0vfv3qb556T6SuMbYzSCm4uPq82d1Bcsqimvsaf2jjUea0gUC0uM3ab12mqZVstsWmetlmlZp4Nhz3BduN5cSz0X6Uyks6FLMQkh4i7ikPARpJRPER6cmSeN5qujZ+ZJf9A1IELLxTxN4ijkQTABwAag4wD7SbttEYIQHr4om42Tft8xIETr1VoprbUOw3DkuhDCbre3t9frAMfzxsTbz261zVbbbLfNlm02mqfeGO8/r1ar5WIxK0shBOccQug4TvcAAIAQkqZpEASUUs75dDqN4yhJkrqujNHI3aw3ZVlKKRljnuf1+/3uMwAAjHFRFFEU+b4fHKCUTiYTpZRBKVuv11mW5XmeJAmEECH0oiyEIIRMJpPxM4QQKaWR53lVVUEQxHGMMQYAHDcfy7NZpZRiB8IDjLGiKAylVFXNKKNxHP8/+F8ZoeVqtd1utVZCxJzzMAwppVmW/QHRMdRU0rEz0gAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9e0b777024a44170612a3f920362d98a/e4706/OpenHAB_Auto_Discovery_12.avif 230w", "/de/static/9e0b777024a44170612a3f920362d98a/d1af7/OpenHAB_Auto_Discovery_12.avif 460w", "/de/static/9e0b777024a44170612a3f920362d98a/7f308/OpenHAB_Auto_Discovery_12.avif 920w", "/de/static/9e0b777024a44170612a3f920362d98a/7a54e/OpenHAB_Auto_Discovery_12.avif 1018w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/9e0b777024a44170612a3f920362d98a/a0b58/OpenHAB_Auto_Discovery_12.webp 230w", "/de/static/9e0b777024a44170612a3f920362d98a/bc10c/OpenHAB_Auto_Discovery_12.webp 460w", "/de/static/9e0b777024a44170612a3f920362d98a/966d8/OpenHAB_Auto_Discovery_12.webp 920w", "/de/static/9e0b777024a44170612a3f920362d98a/5304f/OpenHAB_Auto_Discovery_12.webp 1018w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/9e0b777024a44170612a3f920362d98a/81c8e/OpenHAB_Auto_Discovery_12.png 230w", "/de/static/9e0b777024a44170612a3f920362d98a/08a84/OpenHAB_Auto_Discovery_12.png 460w", "/de/static/9e0b777024a44170612a3f920362d98a/c0255/OpenHAB_Auto_Discovery_12.png 920w", "/de/static/9e0b777024a44170612a3f920362d98a/3dde1/OpenHAB_Auto_Discovery_12.png 1018w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/9e0b777024a44170612a3f920362d98a/c0255/OpenHAB_Auto_Discovery_12.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Das benötiget Topic lautet demnach:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`openhab_discovery/button/203/goto_preset_one/config`}</code></li>
    </ul>
    <p>{`Davon benötigt man nur den `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`button/203/goto_preset_one`}</code>{` Teil in der Liste der MQTT Topics:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "724px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/bd355c877293686959e5c4145cb087f7/a242d/OpenHAB_Auto_Discovery_13.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "58.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAIAAADtbgqsAAAACXBIWXMAAAsTAAALEwEAmpwYAAABDUlEQVQoz42S0ZLCIAxF+QVX2pJAqLVS3UKga906Pvj/v7WrzLraB/XOGQYezoRMIs7n8+l0mqaJiBaLhZRy+UY+rhHTNB2Px773bbsxhhC11uY5iLpp1mVZihjTMHwxxxhT3/umWRPZ52htUhoA4CIzR+9DCMwcc/2XcgisFIiUBuYYQogxrVYNon6n8r+c0tD33rmurlcvzSwzX+VxPOz3Ywj88rePPadLz851znVtuyGyxlDm/p6f1tY3iKxzXVUpQUQAoHVulf7OW6y1FhGrxxRFuVxK4X3YbnfW2jzDXOp+qsYQAFaVukcpkFKKw+F7HMfd7nPmzJiFiIqiFMYYpRQiAsDzjZzxu54/9MVTzqKZw64AAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bd355c877293686959e5c4145cb087f7/e4706/OpenHAB_Auto_Discovery_13.avif 230w", "/de/static/bd355c877293686959e5c4145cb087f7/d1af7/OpenHAB_Auto_Discovery_13.avif 460w", "/de/static/bd355c877293686959e5c4145cb087f7/671c7/OpenHAB_Auto_Discovery_13.avif 724w"],
              "sizes": "(max-width: 724px) 100vw, 724px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/bd355c877293686959e5c4145cb087f7/a0b58/OpenHAB_Auto_Discovery_13.webp 230w", "/de/static/bd355c877293686959e5c4145cb087f7/bc10c/OpenHAB_Auto_Discovery_13.webp 460w", "/de/static/bd355c877293686959e5c4145cb087f7/79561/OpenHAB_Auto_Discovery_13.webp 724w"],
              "sizes": "(max-width: 724px) 100vw, 724px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bd355c877293686959e5c4145cb087f7/81c8e/OpenHAB_Auto_Discovery_13.png 230w", "/de/static/bd355c877293686959e5c4145cb087f7/08a84/OpenHAB_Auto_Discovery_13.png 460w", "/de/static/bd355c877293686959e5c4145cb087f7/a242d/OpenHAB_Auto_Discovery_13.png 724w"],
              "sizes": "(max-width: 724px) 100vw, 724px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/bd355c877293686959e5c4145cb087f7/a242d/OpenHAB_Auto_Discovery_13.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Man kann sich jetzt frei in an den vorhandenen Topics bedienen und hinzufügen was man benötigt.`}</p>
    <p>{`Nach dem Speichern sind jetzt sowohl der MQTT Broker als auch die Kamera (als Home Assistant Komponente) in OpenHAB hinzugefügt:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/782f5218519ab10ad6ffec868e9a69b0/6d74e/OpenHAB_Auto_Discovery_14.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "29.130434782608695%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAAsTAAALEwEAmpwYAAABCElEQVQY013PS07DMBAG4JyA5kGbhz2pbSbjurZjGyULSiukXoBt13AMLsCGLedFtFAhvtWvkWb0T7bdbonIO7cWYtToN4TDQL8QMaUUQkTE63AgMkSOMAshWGtDCADAOAgpAaDtvvGz7k++AgDOeSaEaJqmruumaRaLBSJaa5VSUkrOeV3Xl/36rG1bxthquarKssjzbP901NajNhKpqqphGKZpOhwO8zxrTVJK55wx5nJOa+2934yGr6Eoiky9frLT+/L00Ty/lberGNPDbj9Pc0z3St31/ZqxS80eoOcMGMDu5YiR8ps8G+cduaTMKMiWZaW1jjH5cfz5tu3af7rOPDouociLL8RgMmdvdkd+AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/782f5218519ab10ad6ffec868e9a69b0/e4706/OpenHAB_Auto_Discovery_14.avif 230w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/d1af7/OpenHAB_Auto_Discovery_14.avif 460w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/7f308/OpenHAB_Auto_Discovery_14.avif 920w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/8a1c1/OpenHAB_Auto_Discovery_14.avif 1085w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/782f5218519ab10ad6ffec868e9a69b0/a0b58/OpenHAB_Auto_Discovery_14.webp 230w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/bc10c/OpenHAB_Auto_Discovery_14.webp 460w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/966d8/OpenHAB_Auto_Discovery_14.webp 920w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/9c2f0/OpenHAB_Auto_Discovery_14.webp 1085w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/782f5218519ab10ad6ffec868e9a69b0/81c8e/OpenHAB_Auto_Discovery_14.png 230w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/08a84/OpenHAB_Auto_Discovery_14.png 460w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/c0255/OpenHAB_Auto_Discovery_14.png 920w", "/de/static/782f5218519ab10ad6ffec868e9a69b0/6d74e/OpenHAB_Auto_Discovery_14.png 1085w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/782f5218519ab10ad6ffec868e9a69b0/c0255/OpenHAB_Auto_Discovery_14.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "nutzung-der-kamera",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#nutzung-der-kamera",
        "aria-label": "nutzung der kamera permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Nutzung der Kamera`}</h2>
    <p>{`In der hinzugefügten Kamera (als Home Assistant MQTT Komponente) stehen einem danach alle Funktionen als Kanäle zur Verfügung, die man während der Konfiguration hinzugefügt hatte:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/24eadd0be27e56ae4968246453bd9ed4/d5bfb/OpenHAB_Auto_Discovery_15.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "42.173913043478265%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABS0lEQVQY032QTU/jMBCG8w9Qsdsmtmccf4+TJqYBJBoogiKxlz1yQXtaaX/Jnjnwk4F2j2gfPaeRXs3MWxHROI7DMJRSQEmnAfALOOK8vyhlOw7jMFhrT0PU2iLEFiutdUzU9X3uutVqzTiXUmpEcURKKZpGi1qIRkolhKjrGgAaIRjn1baMwbXNios1r9dLxlgIMedMRN4Ha60xJsRkjGnb1hhDRM45RDxfLKqbxx+XDz/txeymO+V7xs6J8jRN2+00TZMxBhFDCPjvFwwhGmOUUoyxyjz/Cb/f65e/9evbav+LLc5SyofHw/39w9XVNQAqBVIqpeCklEpKBYCcLyuKfuzJmzZYDVIwxlOiw+Fp3s2Uvi4EwG/lnFcxptz1znsfAgAwxlKi3c0u526z2fw3vKxyzqUUf+QUDiHu7/bzfOucP/atvvVz8wfvkkHeAYjKCQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/24eadd0be27e56ae4968246453bd9ed4/e4706/OpenHAB_Auto_Discovery_15.avif 230w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/d1af7/OpenHAB_Auto_Discovery_15.avif 460w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/7f308/OpenHAB_Auto_Discovery_15.avif 920w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/f768f/OpenHAB_Auto_Discovery_15.avif 1072w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/24eadd0be27e56ae4968246453bd9ed4/a0b58/OpenHAB_Auto_Discovery_15.webp 230w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/bc10c/OpenHAB_Auto_Discovery_15.webp 460w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/966d8/OpenHAB_Auto_Discovery_15.webp 920w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/f13ee/OpenHAB_Auto_Discovery_15.webp 1072w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/24eadd0be27e56ae4968246453bd9ed4/81c8e/OpenHAB_Auto_Discovery_15.png 230w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/08a84/OpenHAB_Auto_Discovery_15.png 460w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/c0255/OpenHAB_Auto_Discovery_15.png 920w", "/de/static/24eadd0be27e56ae4968246453bd9ed4/d5bfb/OpenHAB_Auto_Discovery_15.png 1072w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/24eadd0be27e56ae4968246453bd9ed4/c0255/OpenHAB_Auto_Discovery_15.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Diese können dann mit „Items“ verknüpft werden:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/6dccea3f59dcd9054ddc11cd2883b802/ee9b6/OpenHAB_Auto_Discovery_16.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "69.56521739130434%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3ElEQVQoz2WSy6oTQRCGZy8IyfRk+n6t7rnfciaRMwdEwY1LceNefABfwbVb31fSnYQc/SiGprt+quqvybQ2xlilNABwzrzklBBKKb8gGON1XY/j1PeD1poxxh/ImqY5n8+nCMZ4t9u1Xae1LooCRfIbCKHiAYRQZowtDiVCh+JQxgN6elpPp1NdN96HKgLgQ6gAgMSmEhjj7P3zu22dKyMqwxTD+/3eGEsplVISQouiLMvycLh+7+0gFCs3X362P/6Qr7/Kb7/xx+/o7ZvzODxv28v2AgDsXy5GcC6EkBiTzE1b2D7r4we9fmL1Md/ttBAkgnFJCBEPcC7iPU4JWRNgbANo7o2QDOcIhaoWQqYKSullOU7TPE3zPC/jOFnrGONKaWNsVlVV23bOAXgvpESo6LpeSpX0xtiu652DFNa6+CRSwmVV8zx77wFACIEQ0trE4S45QkitjVJaCJkGTpfXmadpWpalqirnnJQyz3Mf4Zwnz611lHLG7nH17TLzsizrurZtCwBJ3PfDPC/WOkKolMo5oJQ9iHlqgVKW9X0/DENq+1Y5hFBZCynpvp57JMOsdZm9kWbOcwTeW2tv/28SvIIxJqVSSmXuxlW8z5sQun64G/N/xBVeXPwLR4tqGzqDSecAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/6dccea3f59dcd9054ddc11cd2883b802/e4706/OpenHAB_Auto_Discovery_16.avif 230w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/d1af7/OpenHAB_Auto_Discovery_16.avif 460w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/7f308/OpenHAB_Auto_Discovery_16.avif 920w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/d45c9/OpenHAB_Auto_Discovery_16.avif 1041w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/6dccea3f59dcd9054ddc11cd2883b802/a0b58/OpenHAB_Auto_Discovery_16.webp 230w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/bc10c/OpenHAB_Auto_Discovery_16.webp 460w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/966d8/OpenHAB_Auto_Discovery_16.webp 920w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/e0a35/OpenHAB_Auto_Discovery_16.webp 1041w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/6dccea3f59dcd9054ddc11cd2883b802/81c8e/OpenHAB_Auto_Discovery_16.png 230w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/08a84/OpenHAB_Auto_Discovery_16.png 460w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/c0255/OpenHAB_Auto_Discovery_16.png 920w", "/de/static/6dccea3f59dcd9054ddc11cd2883b802/ee9b6/OpenHAB_Auto_Discovery_16.png 1041w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/6dccea3f59dcd9054ddc11cd2883b802/c0255/OpenHAB_Auto_Discovery_16.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Und stehen danach als Schaltflächen in der OpenHAB Oberfläche zur Nutzung bereit:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/df204cc2507da7a545423efdca0984ed/c6ff8/OpenHAB_Auto_Discovery_17.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "43.913043478260875%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAABi0lEQVQoz1WQu27cMBBF9QPBrvgSRXJIipS1kmxxJe3qBQcLF0GQJlUQd+nzCWlTpt8upX80kDYO4oNp5s4dzMVEABoAlAJtrBKiMGsLAFLKsiyneR6nKXT9NM1913vnlVI3gzc6qut62Difz4QQTEj6CuecUpZZ8/H9wjlPkoT/N8IYR875NBWEJZQllDJCiNZmi6O1NlzC+ZC/PF9gvfdXB9BSKoRw9LhMQ9/eOXvwmZIijmNKabLBGKOMSUZDsmdvoZQhhKLiy4/y+2/2/Cv5dqXLVxq/A613u91+v4/jGCGEMUaEYIzJK6uyEZXtdD89uWZ0x1nYgmDchOM8L+M4VVWdZe6W39pMa6ONUQKqpQkf+ngXR2WR10Xurb5zRgqOMXHF4Xg6hf7UhPDw0NT1fXE4eO+ttcYYo3XmXZa79XJVVSEE732e51JKhPBQlp8vl0/LPLRt23YhHL3PpVT/vmVBg4L1YVVVNU2Tb9yWf3bNdeyuQ/eUWcxTkQohpJTqVkqqCsCuTvQHu3JIVEauewoAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/df204cc2507da7a545423efdca0984ed/e4706/OpenHAB_Auto_Discovery_17.avif 230w", "/de/static/df204cc2507da7a545423efdca0984ed/d1af7/OpenHAB_Auto_Discovery_17.avif 460w", "/de/static/df204cc2507da7a545423efdca0984ed/7f308/OpenHAB_Auto_Discovery_17.avif 920w", "/de/static/df204cc2507da7a545423efdca0984ed/bb153/OpenHAB_Auto_Discovery_17.avif 1088w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/df204cc2507da7a545423efdca0984ed/a0b58/OpenHAB_Auto_Discovery_17.webp 230w", "/de/static/df204cc2507da7a545423efdca0984ed/bc10c/OpenHAB_Auto_Discovery_17.webp 460w", "/de/static/df204cc2507da7a545423efdca0984ed/966d8/OpenHAB_Auto_Discovery_17.webp 920w", "/de/static/df204cc2507da7a545423efdca0984ed/a9e21/OpenHAB_Auto_Discovery_17.webp 1088w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/df204cc2507da7a545423efdca0984ed/81c8e/OpenHAB_Auto_Discovery_17.png 230w", "/de/static/df204cc2507da7a545423efdca0984ed/08a84/OpenHAB_Auto_Discovery_17.png 460w", "/de/static/df204cc2507da7a545423efdca0984ed/c0255/OpenHAB_Auto_Discovery_17.png 920w", "/de/static/df204cc2507da7a545423efdca0984ed/c6ff8/OpenHAB_Auto_Discovery_17.png 1088w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/df204cc2507da7a545423efdca0984ed/c0255/OpenHAB_Auto_Discovery_17.png",
              "alt": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "title": "OpenHAB MQTT Discovery für INSTAR Kameras",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/FAQs/"
        }}>{`FAQs`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9420WQHD/"
            }}>{`IN-9420 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9408WQHD/"
            }}>{`IN-9408 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8415WQHD/"
            }}>{`IN-8415 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8403WQHD/"
            }}>{`IN-8403 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8401WQHD/"
            }}>{`IN-8401 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9020FHD/"
            }}>{`IN-9020 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9010FHD/"
            }}>{`IN-9010 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9008FHD/"
            }}>{`IN-9008 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8015FHD/"
            }}>{`IN-8015 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8003FHD/"
            }}>{`IN-8003 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8001FHD/"
            }}>{`IN-8001 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-7011HD/"
            }}>{`IN-7011 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6014HD/"
            }}>{`IN-6014 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6012HD/"
            }}>{`IN-6012 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6001HD/"
            }}>{`IN-6001 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-5907HD/"
            }}>{`IN-5907 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-5905HD/"
            }}>{`IN-5905 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/VGA_Series/"
            }}>{`VGA Series`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      